export default __webpack_public_path__ + "static/media/route-line.b29e18a8.svg";